"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Checks if the Snowplow tracker exists by seeing if it is saved to the window
 */
var isReady = function isReady() {
  return typeof window !== 'undefined' && window.snowplow !== undefined;
};
exports["default"] = isReady;